import { Select } from 'antd'

export function PaginationBar({
  page,
  totalRows,
  pageSize,
  onPageChange,
}: {
  page: number
  totalRows: number
  pageSize: number
  onPageChange: (p: number) => void
}) {
  const safePageSize = Math.max(pageSize, 1)
  const safeTotalRows = Math.max(totalRows, 0)
  const pageCount = Math.ceil(safeTotalRows / safePageSize)
  if (pageCount <= 1) return null
  const currentPage = Math.min(Math.max(page, 1), pageCount)
  const options = Array.from({ length: pageCount }, (_, i) => ({ value: i + 1, label: String(i + 1) }))
  const start = (currentPage - 1) * safePageSize + 1
  const end = Math.min(currentPage * safePageSize, safeTotalRows)
  return (
    <div className="flex items-center justify-between px-3 py-2 border-t border-gray-100 text-xs text-gray-500 bg-white sticky bottom-0">
      <span>{start}–{end} of {safeTotalRows}</span>
      <div className="flex items-center gap-1">
        <button type="button" onClick={() => onPageChange(1)} disabled={currentPage === 1} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">«</button>
        <button type="button" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">Prev</button>
        <Select
          size="small"
          showSearch
          value={currentPage}
          onChange={onPageChange}
          options={options}
          style={{ width: 72 }}
          filterOption={(input, opt) => opt?.label?.startsWith(input) ?? false}
        />
        <button type="button" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === pageCount} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">Next</button>
        <button type="button" onClick={() => onPageChange(pageCount)} disabled={currentPage === pageCount} className="px-2 py-1 rounded border border-gray-200 disabled:opacity-40 hover:bg-gray-50">»</button>
      </div>
    </div>
  )
}
